import { useEffect, useState } from 'react';
import { NotificationGroup, NotificationColor } from '@/shared/types/message';
import { notificationService } from '../services/NotificationService';

export const useNotification = () => {
  const [groups, setGroups] = useState<Record<NotificationColor, NotificationGroup | null>>({
    brand: null,
    neutral: null,
  });

  useEffect(() => {
    // Obtener estado inicial
    setGroups(notificationService.getGroups());

    // Suscribirse a cambios
    const unsubscribe = notificationService.subscribe((newGroups) => {
      setGroups({ ...newGroups });
    });

    return () => {
      unsubscribe();
    };
  }, []);

  // Obtener grupos activos (no null y no saliendo)
  // Nota: Los grupos con isLeaving se excluyen de activeGroups para evitar
  // renderizar notificaciones que están en proceso de salida
  const activeGroups = Object.values(groups).filter(
    (group): group is NotificationGroup => group !== null && !group.isLeaving,
  );

  // Obtener grupos que están saliendo (para animación)
  // Estos se mantienen en el estado pero no se renderizan como "activos"
  const leavingGroups = Object.values(groups).filter(
    (group): group is NotificationGroup => group !== null && group.isLeaving,
  );

  return {
    groups,
    activeGroups,
    leavingGroups,
    dismissGroup: (color: NotificationColor) => notificationService.dismissGroup(color),
  };
};
